import { render, staticRenderFns } from "./ReviewsSettings.vue?vue&type=template&id=4c6d4e02&scoped=true"
import script from "./ReviewsSettings.vue?vue&type=script&lang=js"
export * from "./ReviewsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6d4e02",
  null
  
)

export default component.exports